import React, {PureComponent} from 'react';
import TranslatedText from '../../atoms/TranslatedText';

export default class TruBridgeSlide extends PureComponent {
    render() {
        const {slide, currentState, currentSlide, changeBridge} = this.props;

        const slideClasses =
            'TruBridge-slide' +
            ' TruBridge-slide-number-' +
            currentSlide +
            ' TruBridge-slide-state-' +
            currentState;

        const bgStyle = {backgroundImage: `url(${slide.states[0].image})`};

        let bgs = slide.states.map((slideState, index) => (
            <div
                className={currentState === index ? 'active' : 'disabled'}
                key={index}>
                <div
                    className={
                        currentState === 1 || currentState === 2
                            ? 'TruBridge-slide-labels active'
                            : 'TruBridge-slide-labels'
                    }>
                    <div
                        className={
                            currentState === 1
                                ? 'TruBridge-slide-label TruBridge-slide-label1 red'
                                : 'TruBridge-slide-label TruBridge-slide-label1 green'
                        }>
                        <TranslatedText tag={slideState.label1} />
                    </div>
                    <div
                        className={
                            currentState === 1
                                ? 'TruBridge-slide-label TruBridge-slide-label2 red'
                                : 'TruBridge-slide-label TruBridge-slide-label2 green'
                        }>
                        <TranslatedText tag={slideState.label2} />
                    </div>
                    <div
                        className={
                            currentState === 1
                                ? 'TruBridge-slide-label TruBridge-slide-label3 red'
                                : 'TruBridge-slide-label TruBridge-slide-label3 green'
                        }>
                        <TranslatedText tag={slideState.label3} />
                    </div>
                </div>
                <img src={slideState.image} />
            </div>
        ));

        let buttonState = currentState == 0 ? '' : 'fadeout';

        return (
            <div className={slideClasses}>
                <div className="TruBridge-slide-bgs" style={bgStyle}>
                    {bgs}
                </div>
                <div className="TruBridge-slide-bottom-bar">
                    <button
                        onClick={() => changeBridge(1)}
                        className={currentState === 1 ? 'red' : buttonState}>
                        <div className="TruBridge-btn-image">
                            <img src={slide.bridge1} alt="" />
                            <span>{slide.bridge1Label}</span>
                        </div>
                        <TranslatedText tag={slide.btn1} />
                    </button>
                    <button
                        onClick={() => changeBridge(2)}
                        className={currentState === 2 ? 'green' : buttonState}>
                        <div className="TruBridge-btn-image">
                            <img src={slide.bridge2} alt="" />
                            <span>{slide.bridge2Label}</span>
                        </div>
                        <TranslatedText tag={slide.btn2} />
                    </button>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/trueBridge/TruBridgeSlide.js